import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipDefaultOptions } from '@angular/material/tooltip';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AbstractSecurityStorage } from 'angular-auth-oidc-client';
import player from 'lottie-web';
import { LottieCacheModule, LottieModule } from 'ngx-lottie';

import { OidcStorageService } from '@app/services/oidc-storage.service';
import { SharedStoreModule } from '@dashboards/store/shared-store.module';
import { NotificationsModule } from '@main-application/notifications/notifications.module';
import { PortfolioStoreModule } from '@portfolio/store/portfolio-store.module';
import { ValueIfNonZeroPipe } from '@shared/pipes/valueIfNonZero.pipe';
import { ValueIfPositivePipe } from '@shared/pipes/valueIfPositive.pipe';
import { YesEmptyPipe } from '@shared/pipes/yesEmpty.pipe';
import { SharedModule } from '@shared/shared.module';
import { SingletonServicesModule } from '@shared/singleton-service.module';
import { ModalsModule } from '@ui-components/modals/modals.module';
import { environment } from 'src/environments/environment';
import { EnvironmentType } from 'src/environments/environment-config';

import { MainApplicationComponent } from './main-application.component';
import { MainApplicationRoutingModule } from './main-application.routing.module';

export function playerFactory() {
  return player;
}

export const tooltipDefaults: MatTooltipDefaultOptions = {
  showDelay: 200,
  hideDelay: 0,
  touchendHideDelay: 1500,
};

@NgModule({
  declarations: [MainApplicationComponent],
  imports: [
    LottieModule.forRoot({ player: playerFactory }),
    LottieCacheModule.forRoot(),
    CommonModule,
    NotificationsModule, //ToDo: check what is it and where it should be registered

    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.type === EnvironmentType.Prod }),
    PortfolioStoreModule,
    SharedStoreModule,

    SharedModule,
    SingletonServicesModule,

    ModalsModule,
    ScrollingModule,
    FormsModule,
    ReactiveFormsModule,

    MatDialogModule,
    MatSnackBarModule,

    MainApplicationRoutingModule,
  ],
  providers: [
    YesEmptyPipe,
    ValueIfPositivePipe,
    ValueIfNonZeroPipe,
    { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: tooltipDefaults },
    { provide: AbstractSecurityStorage, useClass: OidcStorageService },
  ],
})
export class MainApplicationModule {}
